import { all, call, put } from "@redux-saga/core/effects";
import { push } from "connected-react-router";
import { takeEvery } from "redux-saga/effects";
import { UserActivateAutoLoginAction, USER_ACTIVATE_AUTO_LOGIN, USER_ACTIVATE_AUTO_LOGIN_FAILURE, } from "~/actions/activate";
import { raiseRouteOverwatchUsrProfile } from "~/actions/routeOverwatch";
import authProvider, { OdAuthProvider } from "~/authProvider/authProvider";
import retrieveAxiosErr from "~/utils/retrieveAxiosErr";



export function handleAutoLogin(authProvider: OdAuthProvider) {
  return function* handleAutoLogin(action: UserActivateAutoLoginAction) {
    const { payload } = action
    try
    {
      yield call(authProvider.login.bind(authProvider), {
        type: 'ActivateAutoLogin',
        ...payload,
      })
    } catch (err) {
      let errMsg = retrieveAxiosErr(err)

      // store errMsg into redux store
      yield put({
        type: USER_ACTIVATE_AUTO_LOGIN_FAILURE,
        payload: { data: { id: -1, errMsg } },
        requestPayload: { id: -1 },
        meta: {
          resource: 'autologin',
          fetchResponse: 'GET_ONE',
          fetchStatus: 'RA/FETCH_END',
        }
      })

      yield put(push('/login'))
      return
    }

    yield put(raiseRouteOverwatchUsrProfile())

  }
}

export default function* activateSaga() {
  yield all([
    takeEvery(USER_ACTIVATE_AUTO_LOGIN, handleAutoLogin(authProvider)),
  ])
}
